import React from 'react';
import PropTypes from 'prop-types';
import Button, { outline } from '@narvar/nth-button';
import ExpandIcon from './components/ExpandIcon';
import s from './buttonMenu.module.css';
import { Language } from '../Language';

const ButtonMenu = ({
  menuItems,
  itemKey,
  formKey,
  propName,
  itemClick,
  multipleSelect,
  checkSelected,
  disabled,
}) => (
  <div>
    {menuItems.map((menuItem, index) => {
      const isSelected = checkSelected(menuItem, propName, formKey);
      let className = `${s.menu_item} narvar-btn-secondary menu-btn sidebar-action-btn returns-sidebar-button-${index}`;
      const hasMessage = menuItem.language || menuItem.message;
      if (isSelected) {
        className = `${className} returns-sidebar-button-selected`;
      }
      const style = {
        marginTop: '0.3125rem',
        marginBottom: '0.3125rem',
        ...(isSelected ? outline({ active: true }) : outline()),
        ...(hasMessage ? { height: 'auto', paddingTop: '10px', paddingBottom: '10px' } : {}),
      };

      return (
        <Button
          key={menuItem[itemKey]?.toString() || `button-menu-item-${index}`}
          className={className}
          big
          onClick={() => itemClick(index, menuItem)}
          s={style}
          disabled={disabled || !!menuItem.disabled}
        >
          <span data-test={`sidebar-action-btn-${index}`}>{menuItem[propName]}</span>
          <ExpandIcon className={s.expand_icon} expandable={!!isSelected && !multipleSelect} />
          {hasMessage && (
            <Language
              tagName="div"
              style={{ fontWeight: 'initial', marginTop: '10px' }}
              content={menuItem.message}
              {...(menuItem.language || {})}
            />
          )}
        </Button>
      );
    })}
  </div>
);

ButtonMenu.propTypes = {
  menuItems: PropTypes.array,
  itemKey: PropTypes.string.isRequired,
  formKey: PropTypes.string,
  propName: PropTypes.string.isRequired,
  itemClick: PropTypes.func.isRequired,
  checkSelected: PropTypes.func.isRequired,
  multipleSelect: PropTypes.bool,
  disabled: PropTypes.bool,
};

ButtonMenu.defaultProps = {
  menuItems: [],
  formKey: undefined,
  multipleSelect: false,
  disabled: false,
};

export default ButtonMenu;
